import { FC } from 'react';
import { CampaignsTable, CampaignsTableSearch } from './CampaignsTable';

export const CampaignsList: FC = () => {
  return (
    <div className='flex flex-col gap-4'>
      <CampaignsTableSearch />
      <CampaignsTable />
    </div>
  );
};
